export const vendorsColumns = [
  {
    field: "name",
    headerName: "Name",
    minWidth: 150,
    width: 520,
  }
  ];
